module.exports = __webpack_public_path__ + "img/8Y6.32f99803.png";